var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstatingAcademy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 7.5H17.5V8.8125H11.375V7.5ZM11.375 5.3125H17.5V6.625H11.375V5.3125ZM11.375 9.6875H17.5V11H11.375V9.6875ZM18.375 0.5H2.625C1.6625 0.5 0.875 1.2875 0.875 2.25V13.625C0.875 14.5875 1.6625 15.375 2.625 15.375H18.375C19.3375 15.375 20.125 14.5875 20.125 13.625V2.25C20.125 1.2875 19.3375 0.5 18.375 0.5ZM18.375 13.625H10.5V2.25H18.375V13.625Z",
    fill: "#68778A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstatingAcademy);
export default __webpack_public_path__ + "static/media/estating-academy.2229a626d5d8eab5b8750c9924b76077.svg";
export { ForwardRef as ReactComponent };